import { render } from "./ReportCredit.vue?vue&type=template&id=2138539a"
import script from "./ReportCredit.vue?vue&type=script&lang=js"
export * from "./ReportCredit.vue?vue&type=script&lang=js"

import "./ReportCredit.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__